export function setCookie(cname: string, cvalue: string, exdays: number) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function getCookie(cname: string) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export type CookieStatus = 'accepted' | 'undecided' | 'complete' | 'functional' | 'limited'

export type CookieSettingsState = { cookieStatus: CookieStatus; unsubListener: () => void }

const cookiesAcceptedEvent = 'cookies_accepted'

export const getCookieStatus = (): CookieStatus => {
  const cookiesCookie: CookieStatus  = getCookie('cookies') as CookieStatus
  return cookiesCookie ? cookiesCookie : 'undecided' as CookieStatus
}

export const acceptCookies = (level?: CookieStatus) => {
  setCookie('cookies', level ? level : 'complete', 30)
  const event = new CustomEvent(cookiesAcceptedEvent)
  window.dispatchEvent(event)
  if ((window as any).dataLayer) {
    ;(window as any).dataLayer.push(cookiesAcceptedEvent)
  }
}

export const rejectCookies = (currentStatus: CookieStatus) => {
  setCookie('cookies', 'rejected', 30)
  if (currentStatus === 'accepted') window.location.reload()
}

export const updateCookieStatus = (s: CookieSettingsState): CookieSettingsState => ({
  ...s,
  cookieStatus: getCookieStatus()
})

export const addAcceptCookiesListener = (onCookiesAccepted: () => void): (() => void) => {
  window.addEventListener(cookiesAcceptedEvent, onCookiesAccepted)

  return () => window.removeEventListener(cookiesAcceptedEvent, onCookiesAccepted)
}



// WEBPACK FOOTER //
// ./Client/components/cms/blocks/cookiebar.utils.mod.ts